// [COPIAR CÓDIGO]
//
/* GS://PROTOCOLO
 * Arquivo: C:\Users\Usuario\GoldenSisters_Project\goldensisters_admin_web\src\pages\CategoriesPage.js
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema GoldenSisters
 * Versão: 1.2 – Padronização Visual (Light Mode).
 * Impacto da Versão: [src/pages/CategoriesPage.js]
 * Data: 01/12/2025
 * Responsável: Gemini (conforme Protocolo)
 *
 * Mudanças desta versão:
 * - MODIFICADO: Substituição total de classes de estilo Dark Mode por Light Mode (bg-gray-50/bg-white).
 * - MODIFICADO: Ajuste de cores de texto e tabela para garantir contraste e consistência.
 * - MANTIDO: Lógica de CRUD e integração com serviços.
 */
//
import React, { useState, useEffect } from 'react';
import { getCategories, addCategory, updateCategory, deleteCategory } from '../services/firestoreService';
import CategoryForm from '../components/forms/CategoryForm';
import { PlusCircle, Loader2, Trash2, Pencil, Tags } from 'lucide-react';

const CategoriesPage = ({ openModal }) => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchCategories = async () => {
        setIsLoading(true);
        const data = await getCategories();
        setCategories(data);
        setIsLoading(false);
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSave = async (categoryData, id) => {
        if (id) {
            await updateCategory(id, categoryData);
        } else {
            await addCategory(categoryData);
        }
        fetchCategories();
    };

    const handleDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja excluir esta categoria?")) {
            await deleteCategory(id);
            fetchCategories();
        }
    };
    
    const handleEdit = (category) => {
        openModal("Editar Categoria", <CategoryForm onClose={() => openModal(null)} onSave={handleSave} categoryData={category} />, 'lg');
    };

    const handleNew = () => {
        openModal("Nova Categoria", <CategoryForm onClose={() => openModal(null)} onSave={handleSave} />, 'lg');
    };

    return (
        <div className="p-8 bg-gray-50 min-h-screen font-sans">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                        Categorias
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">Organização de produtos e SKUs</p>
                </div>
                <button onClick={handleNew} className="mt-4 md:mt-0 flex items-center bg-brand-gold text-brand-black font-semibold px-4 py-2 rounded-lg shadow-md hover:bg-yellow-500 transition-colors">
                    <PlusCircle className="h-5 w-5 mr-2" />
                    Nova Categoria
                </button>
            </div>

            {/* Tabela Card */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
                <table className="w-full text-sm text-left text-gray-600">
                    <thead className="text-xs text-gray-600 uppercase bg-gray-100 border-b border-gray-200">
                        <tr>
                            <th scope="col" className="px-6 py-4 font-semibold">Nome da Categoria</th>
                            <th scope="col" className="px-6 py-4 font-semibold">Prefixo do SKU</th>
                            <th scope="col" className="px-6 py-4 text-center font-semibold">Ações</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {isLoading ? (
                            <tr>
                                <td colSpan="3" className="text-center p-10">
                                    <Loader2 className="h-8 w-8 animate-spin mx-auto text-brand-gold" />
                                    <p className="mt-2 text-gray-400">Carregando categorias...</p>
                                </td>
                            </tr>
                        ) : (
                            categories.map((category) => (
                                <tr key={category.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 font-medium text-gray-900 flex items-center gap-2">
                                        <Tags size={16} className="text-gray-400"/>
                                        {category.name}
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className="font-mono text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded border border-gray-200">
                                            {category.prefix}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center justify-center space-x-2">
                                            <button 
                                                onClick={() => handleEdit(category)} 
                                                className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-full transition-colors" 
                                                title="Editar"
                                            >
                                                <Pencil className="h-4 w-4" />
                                            </button>
                                            <button 
                                                onClick={() => handleDelete(category.id)} 
                                                className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors" 
                                                title="Excluir"
                                            >
                                                <Trash2 className="h-4 w-4" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CategoriesPage;